import { award } from "./award";
import { awardList } from "./awardList";
import { budgetBuilder } from "./budgetBuilder";
import { columns } from "./columns";
import { dictionary } from "./dictionary";
import { form } from "./form";
import { groupRoleList } from "./groupRoleList";
import { modificationList } from "./modificationList";
import { picklists } from "./picklists";
import { project } from "./project";
import { projectList } from "./projectList";
import { proposal } from "./proposal";
import { proposalList } from "./proposalList";
import { researchRoles } from "./researchRoles";
import { shell } from "./shell";
import { subaward } from "./subaward";
import { subawardList } from "./subawardList";
import { taskList } from "./taskList";
import { tenant } from "./tenant";
import { userAccesses } from "./userAccesses";
import { userTaskList } from "./userTaskList";

// import { facetedSearch } from "./facetedSearch";


export default {
	award,
	awards: awardList,
	budgetBuilder,
	dictionary,
	form,
	groupRoles: groupRoleList,
	modifications: modificationList,
	picklists,
	project,
	projects: projectList,
	proposal,
	proposals: proposalList,
	shell,
	subaward,
	subawards: subawardList,
	tasks: taskList,
	userAccesses,
	userTasks: userTaskList,
	// facetedSearch,
	tenant,
	columns,
	researchRoles,
};
